import { AppTable } from './AppTable';

export default AppTable;
